<template>
  <div class="pourquoi-certifier">
    <div class="wrapper" :class="{ 'expanded': visibleSections[0] }">
      <div class="question-title" @click="toggleSection(0)">
        <div class="title">Preuve de naturalité</div>
        <img class="img" :class="{ 'rotated': !visibleSections[0] }" alt="Chevron up" src="/img/chevron-up-7.svg" />
      </div>
      <p class="les-produits-bio" v-show="visibleSections[0]">
        Apporte la preuve à vos clients que vos produits  sont naturels et
        garantis sans produits chimiquesde synthèse.
      </p>
    </div>

    <div class="wrapper" :class="{ 'expanded': visibleSections[1] }">
      <div class="question-title" @click="toggleSection(1)">
        <div class="title">Label de confiance</div>
        <img class="img" :class="{ 'rotated': !visibleSections[1] }" alt="Chevron up" src="/img/chevron-up-7.svg" />
      </div>
      <p class="les-produits-bio" v-show="visibleSections[1]">
        Elle garantit à vos clients que votre produit a été contrôlé par un
        organisme agrée et reconnu sur le marché.
      </p>
    </div>

    <div class="wrapper" :class="{ 'expanded': visibleSections[2] }">
      <div class="question-title" @click="toggleSection(2)">
        <div class="title">Certification exigeante</div>
        <img class="img" :class="{ 'rotated': !visibleSections[2] }" alt="Chevron up" src="/img/chevron-up-7.svg" />
      </div>
      <p class="les-produits-bio" v-show="visibleSections[2]">
        La certification répond à un marché exigeant pour des consommateurs de
        plus en plus attentifs à leur alimentation
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "PourquoiCertifier",
  data() {
    return {
      visibleSections: [false, false, false] // All sections hidden by default
    };
  },
  methods: {
    toggleSection(index) {
      this.visibleSections[index] = !this.visibleSections[index];
      // Force reactivity update
      this.$forceUpdate();
    }
  }
};
</script>

<style>
.pourquoi-certifier {
  align-items: flex-start;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px 12px;
  margin: 0px 8vw;
  align-items: center;
}

.pourquoi-certifier .wrapper {
  align-items: flex-start;
  background-color: #edf2d3b7;
  background-color: #eeeeee;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 24px;
  max-width: -webkit-fill-available;
  transition: all 0.3s ease;
}

.pourquoi-certifier .wrapper.expanded {
  min-height: 150px;
}

.pourquoi-certifier .question-title {
  align-items: center;
  align-self: stretch;
  display: flex;
  flex: 0 0 auto;
  gap: 8px;
  width: 100%;
  height: 24px;
  cursor: pointer;
  user-select: none;
}

.pourquoi-certifier .question-title:hover {
  opacity: 0.8;
}

.pourquoi-certifier .title {
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  color: #1d221b;
  display: -webkit-box;
  flex: 1;
  font-family: "Mona-Sans-Bold", Helvetica;
  font-size: 17px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 24px;
  overflow: hidden;
  position: relative;
  text-overflow: ellipsis;
}

.pourquoi-certifier .img {
  height: 24px;
  width: 24px;
  transition: transform 0.3s ease;
}

.pourquoi-certifier .img.rotated {
  transform: rotate(180deg);
}

.pourquoi-certifier .les-produits-bio {
  align-self: stretch;
  color: #1d221b;
  font-family: "Mona-Sans-Light", Helvetica;
  font-size: 14px;
  font-weight: 300;
  letter-spacing: 0;
  line-height: 18px;
}
@media (max-width: 1200px){
  .pourquoi-certifier {
    grid-template-columns: repeat(1, 1fr);
    margin: 0px 6vw;
  }
}

@media (max-width: 768px) {
  .pourquoi-certifier {
    margin: 0px 6vw;
    gap: 16px;
  }
  .pourquoi-certifier .wrapper {
    padding: 20px;
  }
  .pourquoi-certifier .title {
    font-size: 16px;
  }
  .pourquoi-certifier .les-produits-bio {
    font-size: 13px;
    line-height: 17px;
  }
}

@media (max-width: 480px) {
  .pourquoi-certifier {
    margin: 0px 4vw;
    gap: 12px;
  }
  .pourquoi-certifier .wrapper {
    padding: 16px;
  }
  .pourquoi-certifier .title {
    font-size: 15px;
  }
  .pourquoi-certifier .les-produits-bio {
    font-size: 12px;
    line-height: 16px;
  }
}
</style>